import React, { useState } from 'react';
import { X, BookOpen, User, Clock, Users } from 'lucide-react';

export default function MappingSelectorModal({ isOpen, onClose, onSelect, mappings, facultyList }) {
    const [duration, setDuration] = useState(1);
    const [faculty2Id, setFaculty2Id] = useState('');

    if (!isOpen) return null;

    const handleSelect = (m) => {
        onSelect({
            ...m,
            duration,
            faculty2Id: duration === 3 ? faculty2Id : null
        });
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm animate-in fade-in duration-200">
            <div className="bg-card w-full max-w-md rounded-2xl shadow-xl border border-border overflow-hidden animate-in zoom-in-95 duration-200">
                <div className="flex items-center justify-between p-4 border-b border-border">
                    <h3 className="font-heading font-bold text-lg">Assign Subject & Faculty</h3>
                    <button onClick={onClose} className="p-1 hover:bg-secondary rounded-full transition-colors">
                        <X size={20} className="text-muted-foreground" />
                    </button>
                </div>

                <div className="p-4 border-b border-border bg-muted/20 space-y-4">
                    <div>
                        <label className="text-xs font-semibold uppercase text-muted-foreground mb-2 block">Class Type</label>
                        <div className="grid grid-cols-3 gap-2">
                            <button
                                onClick={() => setDuration(1)}
                                className={`py-2 px-2 rounded-lg text-xs font-bold border transition-all flex flex-col items-center gap-1 ${duration === 1
                                        ? 'bg-primary text-primary-foreground border-primary shadow-sm'
                                        : 'bg-card border-border hover:border-primary/50 text-foreground'
                                    }`}
                            >
                                <Clock size={16} />
                                Standard (1h)
                            </button>
                            <button
                                onClick={() => setDuration(2)}
                                className={`py-2 px-2 rounded-lg text-xs font-bold border transition-all flex flex-col items-center gap-1 ${duration === 2
                                        ? 'bg-blue-500 text-white border-blue-500 shadow-sm'
                                        : 'bg-card border-border hover:border-blue-500/50 text-foreground'
                                    }`}
                            >
                                <BookOpen size={16} />
                                Merge Class (2h)
                            </button>
                            <button
                                onClick={() => setDuration(3)}
                                className={`py-2 px-2 rounded-lg text-xs font-bold border transition-all flex flex-col items-center gap-1 ${duration === 3
                                        ? 'bg-purple-500 text-white border-purple-500 shadow-sm'
                                        : 'bg-card border-border hover:border-purple-500/50 text-foreground'
                                    }`}
                            >
                                <Users size={16} />
                                Lab (3h)
                            </button>
                        </div>
                    </div>

                    {duration === 3 && (
                        <div className="animate-in slide-in-from-top-2 duration-200">
                            <label className="text-xs font-semibold uppercase text-muted-foreground mb-1 block">Secondary Faculty (Lab)</label>
                            <select
                                className="w-full bg-card border border-border rounded-lg px-3 py-2 text-sm focus:ring-1 focus:ring-purple-500"
                                value={faculty2Id}
                                onChange={(e) => setFaculty2Id(e.target.value)}
                            >
                                <option value="">Select Assisting Faculty...</option>
                                {facultyList.map(f => (
                                    <option key={f.id} value={f.id}>{f.name} ({f.email})</option>
                                ))}
                            </select>
                        </div>
                    )}
                </div>

                <div className="p-4 max-h-[50vh] overflow-y-auto space-y-2">
                    {mappings.length === 0 ? (
                        <div className="text-center py-8 text-muted-foreground">
                            <p>No mappings found for this section.</p>
                            <p className="text-xs mt-1">Go to "Faculty Mapping" to assign subjects first.</p>
                        </div>
                    ) : (
                        mappings.map((m) => (
                            <div
                                key={m.id}
                                onClick={() => handleSelect(m)}
                                className="flex items-center gap-4 p-3 rounded-xl border border-border/50 hover:border-primary/50 hover:bg-primary/5 cursor-pointer transition-all group"
                            >
                                <div className="h-10 w-10 bg-secondary rounded-lg flex items-center justify-center text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-colors">
                                    <BookOpen size={20} />
                                </div>
                                <div className="flex-1">
                                    <h4 className="font-semibold text-foreground text-sm">{m.subjectName || 'Unknown Subject'}</h4>
                                    <div className="flex items-center gap-1.5 text-xs text-muted-foreground mt-0.5">
                                        <User size={12} />
                                        <span>{m.facultyName || 'Unknown Faculty'}</span>
                                    </div>
                                </div>
                                <div className="text-xs font-medium text-primary opacity-0 group-hover:opacity-100 transition-opacity">
                                    Assign ({duration}h)
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
}
